import { render, staticRenderFns } from "./DeliveryIban.vue?vue&type=template&id=58d29a71"
import script from "./DeliveryIban.vue?vue&type=script&lang=js"
export * from "./DeliveryIban.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports